import React from 'react'
import Headroom from 'react-headroom'
import Link from '../../components/base/link'
import { fonts, colors } from '../../themes'
import Grid from 'material-ui/Grid';
import CloudIcon from 'material-ui-icons/Cloud'
import VerifiedUserIcon from 'material-ui-icons/VerifiedUser'
import EventIcon from 'material-ui-icons/Event'

const styles = {
  avatar: {
    backgroundColor: colors.green,
    color: colors.white,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    borderRadius: '100%',
  }
}

const stepData = [
  {
    title: <h4 css={{ color: colors.white }}>Centralized<br/>Credentialing</h4>,
    icon: <CloudIcon />,
  },
  {
    title: <h4 css={{ color: colors.white }}>Malpractice<br/>Coverage</h4>,
    icon: <VerifiedUserIcon />,
  },
  {
    title: <h4 css={{ color: colors.white }}>Seamless<br/>Calendaring</h4>,
    icon: <EventIcon />,
  },
]

const Step = ({ step, title, icon }) =>
  <Grid key={step} item xs={12} sm={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', textAlign: 'center', width: '100%', marginBottom: 30, alignSelf: 'stretch', padding: 20 }}>
    <div style={styles.avatar}>
      {icon}
    </div>
    {title}
  </Grid>

const Steps = () => {
  const stepElements = stepData.map((currentStep, index) => <Step {...currentStep} step={index + 1} />)
  return (
    <Grid container spacing={24} style={{ paddingTop: 20, paddingBottom: 20 }}>
      {stepElements}
    </Grid>
  )
}

export default Steps


// WEBPACK FOOTER //
// ./src/components/hybrid/iconPoints.js